type RouteLocation = Pick<Location, "hash" | "pathname">;

/**
 * Resolves the in-app route path for hash-based routers (e.g. `/#/login`).
 */
export function getAppRoutePath(
  location: RouteLocation = typeof window === "undefined"
    ? { hash: "", pathname: "/" }
    : window.location,
): string {
  const hash = location.hash;
  if (hash.startsWith("#/")) {
    const path = hash.slice(1);
    const queryIndex = path.indexOf("?");
    return queryIndex === -1 ? path : path.slice(0, queryIndex);
  }

  return location.pathname || "/";
}
